/**
 * PatientDetailRoute.tsx
 *
 * What /patients/:id renders. A real patient gets PatientDetailPage. The
 * location's "Online Gift Card Sales" placeholder (a system patient, purpose
 * `gift_card_guest`) is not a person, so it gets its own page listing the guest
 * gift card sales instead of the patient record and its tabs.
 *
 * The check reads the same cached query PatientDetailPage loads the patient
 * with (usePatientCore), so it costs no extra request. Until the record
 * arrives the patient page renders as it always has; it is swapped out in the
 * same render the placeholder's record lands, before any of its effects (such
 * as adding the patient to Recently Viewed) run for it.
 */
import { useParams } from 'react-router-dom';
import { usePatientCore } from '@/hooks/usePatientDetail';
import { PatientDetailPage } from '@/pages/PatientDetailPage';
import { OnlineGiftCardSalesPage } from '@/pages/gift-cards/OnlineGiftCardSalesPage';

export const GIFT_CARD_GUEST_PURPOSE = 'gift_card_guest';

export function PatientDetailRoute() {
  const { id } = useParams();
  const patientId = Number(id);
  const valid = Number.isFinite(patientId) && patientId > 0;
  const { data: core } = usePatientCore(valid ? String(patientId) : null);

  if (valid && core?.systemPurpose === GIFT_CARD_GUEST_PURPOSE) {
    return <OnlineGiftCardSalesPage patientId={patientId} />;
  }
  return <PatientDetailPage />;
}
